import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Warning = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1302 2.94143C10.9885 2.67566 10.7145 2.50698 10.4135 2.50021C10.1124 2.49344 9.83111 2.64963 9.67768 2.90876L1.78294 16.2421C1.63042 16.4997 1.62778 16.8193 1.77603 17.0794C1.92429 17.3394 2.20064 17.5 2.5 17.5H17.5C17.7927 17.5 18.0639 17.3465 18.2145 17.0955C18.3651 16.8446 18.3731 16.533 18.2354 16.2748L11.1302 2.94143ZM10 12.5C10.4602 12.5 10.8333 12.1269 10.8333 11.6667V9.16667C10.8333 8.70643 10.4602 8.33333 10 8.33333C9.53976 8.33333 9.16667 8.70643 9.16667 9.16667V11.6667C9.16667 12.1269 9.53976 12.5 10 12.5ZM10.8333 14.1667C10.8333 13.7064 10.4602 13.3333 10 13.3333C9.53976 13.3333 9.16667 13.7064 9.16667 14.1667C9.16667 14.6269 9.53976 15 10 15C10.4602 15 10.8333 14.6269 10.8333 14.1667Z"
      fill={color}
    />
  </svg>
);

Warning.propTypes = {
  color: string,
  size: number,
};

Warning.defaultProps = {
  color: N400,
  size: 20,
};

export default Warning;
